export const createCatalogoModel = ({
  id_catalogo = '',
  catalogo = '',
  estrutura = []
} = {}) => ({
  id_catalogo,
  catalogo,
  estrutura
});